// extracted by mini-css-extract-plugin
module.exports = {"root":"ExpandButton__root___1lM9x"};